import { type SVGProps } from 'react';

export const StandardArrowRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    focusable="false"
    height="1em"
    role="img"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.47 19.47l6.72-6.72H4v-1.5h14.19l-6.72-6.72 1.06-1.06L21.06 12l-8.53 8.53-1.06-1.06z"
      fill="currentColor"
    />
  </svg>
);
